module.exports = __webpack_public_path__ + "static/media/resonance.4c1d217b.svg";